import COENCO from '../../assets/images/Logos/Partners/COENCO.webp';
import MAKESENSE from '../../assets/images/Logos/Partners/MAKESENSE.webp';
import PG from '../../assets/images/Logos/Partners/PG.webp';
import SEMARNAT from '../../assets/images/Logos/Partners/SEMARNAT.webp';
import TEC from '../../assets/images/Logos/Partners/TEC.webp';
import UNITEDWAY from '../../assets/images/Logos/Partners/UNITEDWAY.webp';
import YOUNGWATER from '../../assets/images/Logos/Partners/YOUNGWATER.webp';

export default function LogoCarousel({className}) {

  return (
    <div className="w-full inline-flex flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_64px,_black_calc(100%-64px),transparent_100%)]">
        <ul className="flex items-center justify-center md:justify-start [&_li]:mx-5 [&_img]:max-w-none animate-infinite-scroll">
            <li>
                <img src={COENCO} alt='Bluekali' className='w-32 object-cover'/>
            </li>
            <li>
                <img src={MAKESENSE} alt='Bluekali' className='h-10 object-cover'/>
            </li>
            <li>
                <img src={PG} alt='Bluekali' className='w-14 object-cover'/>
            </li>
            <li>
                <img src={SEMARNAT} alt='Bluekali' className='w-32 object-cover'/>
            </li>
            <li>
                <img src={TEC} alt='Bluekali' className='w-40 object-cover'/>
            </li>
            <li>
                <img src={UNITEDWAY} alt='Bluekali' className='w-24 object-cover'/>
            </li>
            <li>
                <img src={YOUNGWATER} alt='Bluekali' className='w-24 object-cover'/>
            </li>
        </ul>
        <ul className="flex items-center justify-center md:justify-start [&_li]:mx-5 [&_img]:max-w-none animate-infinite-scroll" aria-hidden="true">
            <li>
                <img src={COENCO} alt='Bluekali' className='w-32 object-cover'/>
            </li>
            <li>
                <img src={MAKESENSE} alt='Bluekali' className='h-10 object-cover'/>
            </li>
            <li>
                <img src={PG} alt='Bluekali' className='w-14 object-cover'/>
            </li>
            <li>
                <img src={SEMARNAT} alt='Bluekali' className='w-32 object-cover'/>
            </li>
            <li>
                <img src={TEC} alt='Bluekali' className='w-40 object-cover'/>
            </li>
            <li>
                <img src={UNITEDWAY} alt='Bluekali' className='w-24 object-cover'/>
            </li>
            <li>
                <img src={YOUNGWATER} alt='Bluekali' className='w-24 object-cover'/>
            </li>
        </ul>
    </div>
  );
};